import React
    from 'react';
import './style.scss'
import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import { downloadFile } from 'src/utilities/S3Utils';
import { useSelector } from 'react-redux';


const DownloadableFileListComponent = (props) => {
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    return (
        <SpaceBetween direction='vertical'>
            {props?.filePaths?.map((document, index) => {
                // Extract filename from the path
                const fileName = document?.split('/').pop();
                return (
                    <Button
                        iconName="download"
                        variant="inline-link"
                        onClick={() => downloadFile(document, props?.bucketName, currentStage)}
                        disabled={props?.showDownloadAndView}>
                        {fileName}
                    </Button>
                );
            })}
            {
                props?.filePathsInJson?.map((document, index) => {
                    let documentObj = JSON.parse(document)
                    const fileName = documentObj?.uri?.split('/').pop();
                    if (fileName) {
                        return (
                            <Button
                                key={fileName}
                                iconName="download"
                                variant="inline-link"
                                onClick={() => downloadFile(documentObj?.uri, documentObj?.bucket, currentStage)}
                                disabled={props?.showDownloadAndView}>
                                {fileName}
                            </Button>
                        );
                    }


                })
            }

        </SpaceBetween>
    )
}

export default DownloadableFileListComponent;